// KudosBanner.jsx — Style B certificate card for a single kudos recognition
// Photo if available → initials-in-colour-circle → silhouette fallback
import React from "react";

const NEON = "#00FF99";

const RECOGNITIONS = {
  team_player: { icon: "🤝", label: "TEAM PLAYER", color: NEON      },
  innovator:   { icon: "💡", label: "INNOVATOR",   color: "#c084fc" },
  helpful:     { icon: "🙌", label: "HELPFUL",     color: "#38bdf8" },
  star:        { icon: "⭐", label: "STAR",        color: "#fde047" },
  leader:      { icon: "🚀", label: "LEADER",      color: "#f87171" },
};

const initialsOf = (name = "") => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
};

export default function KudosBanner({
  type = "team_player",
  name,
  photoUrl,
  message,
  fromName,
  compact = false,
}) {
  const meta = RECOGNITIONS[type] || RECOGNITIONS.team_player;
  const col  = meta.color;
  const initials = initialsOf(name);

  return (
    <div
      className="relative rounded-xl border text-center overflow-hidden"
      style={{
        borderColor: `${col}66`,
        background: `linear-gradient(180deg, ${col}14, rgba(0,0,0,0.9))`,
        padding: compact ? "14px 12px 16px" : "20px 16px",
      }}
    >
      <span
        className="absolute top-2 right-2 font-semibold"
        style={{
          color: "#fb923c",
          fontSize: compact ? 8 : 9,
          letterSpacing: "0.1em",
          opacity: 0.75,
        }}
      >
        ★ RECOGNIZED
      </span>

      <div className="flex justify-center mb-2 mt-1">
        <div
          className="flex items-center justify-center overflow-hidden"
          style={{
            width:  compact ? 48 : 60,
            height: compact ? 48 : 60,
            borderRadius: "50%",
            background: photoUrl ? "transparent" : col,
            color: photoUrl ? "transparent" : "#000",
            fontWeight: 700,
            fontSize: compact ? 16 : 20,
            border: `2px solid ${col}99`,
            boxShadow: `0 0 20px ${col}55`,
          }}
        >
          {photoUrl ? (
            <img
              src={photoUrl}
              alt={name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.parentElement.style.background = col;
                e.currentTarget.parentElement.style.color = "#000";
                e.currentTarget.parentElement.innerText = initials;
              }}
            />
          ) : initials && initials !== "?" ? (
            <span>{initials}</span>
          ) : (
            <svg viewBox="0 0 60 60" width="100%" height="100%" opacity="0.8">
              <circle cx="30" cy="22" r="10" fill="#000" />
              <path d="M15,52 Q15,36 30,36 Q45,36 45,52 Z" fill="#000" />
            </svg>
          )}
        </div>
      </div>

      <div style={{ fontSize: compact ? 22 : 28, marginBottom: 2 }}>
        {meta.icon}
      </div>

      <p style={{ color: col, fontSize: compact ? 9 : 10, letterSpacing: "0.2em", fontWeight: 700, margin: 0 }}>
        {meta.label}
      </p>

      <p className="text-white font-semibold" style={{ fontSize: compact ? 13 : 15, margin: "6px 0 2px", lineHeight: 1.3 }}>
        {name || "Colleague"}
      </p>

      {message && (
        <p className="italic" style={{ color: "rgba(255,255,255,0.55)", fontSize: compact ? 10 : 11, margin: 0, lineHeight: 1.3 }}>
          "{message}"
        </p>
      )}

      {fromName && (
        <>
          <div style={{ height: 1, background: "rgba(255,255,255,0.08)", margin: compact ? "8px 0 4px" : "10px 0 6px" }} />
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: compact ? 8 : 9, margin: 0 }}>
            — from {fromName}
          </p>
        </>
      )}
    </div>
  );
}